import React from "react";
import AppButton from "../../../../components/AppButton";
import AppMenu from "../../../../components/AppMenu";
import AppTooltip from "../../../../components/AppTooltip";
import {
  IconChevronDown,
  IconDelete,
  IconEdit,
  IconExport,
  IconLock,
  IconMenu,
  IconSuccess,
} from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const simpleSections = [
  {
    key: "actions",
    items: [
      { key: "edit", label: "Bearbeiten", icon: IconEdit },
      { key: "delete", label: "Löschen", icon: IconDelete, tone: "danger" },
    ],
  },
];

const groupedSections = [
  {
    key: "form",
    title: "Formular",
    items: [
      { key: "edit", label: "Formular bearbeiten", icon: IconEdit },
      { key: "export", label: "Antworten exportieren", icon: IconExport },
    ],
  },
  {
    key: "status",
    title: "Status",
    dividerBefore: true,
    items: [
      { key: "activate", label: "Aktivieren", icon: IconSuccess },
      { key: "close", label: "Formular schliessen", icon: IconLock },
    ],
  },
  {
    key: "danger",
    dividerBefore: true,
    items: [
      { key: "delete", label: "Formular löschen", icon: IconDelete, tone: "danger" },
    ],
  },
];

const niceToKnowItems = [
  "Section-Titel und Divider sind unabhängig voneinander optional.",
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

export default function MenusDocs() {
  return (
    <DocsSectionCard title="Menus">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-menu-preview">
            <PreviewRow label="Einfach">
              <AppMenu
                menuLabel="Beispielaktionen"
                sections={simpleSections}
                renderTrigger={({ triggerProps }) => (
                  <AppTooltip content="Weitere Aktionen">
                    <AppButton {...triggerProps} variant="muted" size="sm" iconOnly aria-label="Weitere Aktionen">
                      <IconMenu />
                    </AppButton>
                  </AppTooltip>
                )}
              />
            </PreviewRow>

            <PreviewRow label="Gruppiert">
              <AppMenu
                sections={groupedSections}
                renderTrigger={({ open, triggerProps }) => (
                  <AppButton {...triggerProps} variant="neutral" size="sm">
                    Verwalten
                    <IconChevronDown
                      sx={{
                        fontSize: 17,
                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 140ms ease",
                      }}
                      aria-hidden="true"
                    />
                  </AppButton>
                )}
              />
            </PreviewRow>

          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
